import Logo from "../components/logo";
import Slider from "../components/slider";
import EpisodeLink from "../components/episodelink";
import Links from "../components/links";
import Photos from "../components/recentphotos";
import Data from "../components/profiledata";
import Interview from "../components/recentinterview";
import Crewlist from "../components/crewlist";
import Footer from "../components/footer";
import Top from "../components/totopbtn";

function Home() {
  return (
    <div>
      <Top />
      <Logo />
      <Slider />
      <div className="content">
        <EpisodeLink />
        <Links />
      </div>
      <Photos />
      <div className="title">Recent Guests</div>
      <Data
        name="Deogratius"
        details="Intervioed IntervioedIntervioedIntervioedIntervioedIntervioedIntervioed IntervioedIntervioed IntervioedIntervioed vIntervioedIntervioed"
      />
      <Interview />
      <Crewlist />
      <Footer />
    </div>
  );
}

export default Home;
